/**
 * 矢量图形类型
 */
export var ShapePrimitiveType;
(function (ShapePrimitiveType) {
    /**
     * 自定义图形
     */
    ShapePrimitiveType[ShapePrimitiveType["Custom"] = 0] = "Custom";
    /**
     * 矩形
     */
    ShapePrimitiveType[ShapePrimitiveType["Rectangle"] = 1] = "Rectangle";
    /**
     * 椭圆
     */
    ShapePrimitiveType[ShapePrimitiveType["Ellipse"] = 2] = "Ellipse";
    /**
     * 多边形
     */
    ShapePrimitiveType[ShapePrimitiveType["Polygon"] = 3] = "Polygon";
    /**
     * 星形
     */
    ShapePrimitiveType[ShapePrimitiveType["Star"] = 4] = "Star";
})(ShapePrimitiveType || (ShapePrimitiveType = {}));
